import React from 'react';

import { ArrowLinkProps } from 'Elements/Link/Arrow';

import { Wrapper, Heading, Subheading, Information, StyledLink } from './Link.styled';

export interface Props {
    heading: string;
    subheading?: string;
    information?: string;
    link?: ArrowLinkProps;
    headingType?: 'h2' | 'h3';
}

const Link: React.FC<Props> = props => {
    const { heading, subheading, information, link, headingType = 'h2' } = props;

    return (
        <Wrapper>
            {subheading ? (
                <Heading as={headingType}>
                    {heading} <br /> <Subheading>{subheading}</Subheading>
                </Heading>
            ) : (
                <Heading as={headingType}>{heading}</Heading>
            )}
            {information && <Information>{information}</Information>}
            {link && <StyledLink {...link} />}
        </Wrapper>
    );
};

export default Link;
